/**
 * UserRole Entity Definition
 */
import { UserRoleRelationSchema } from "../schemas/relations";
import { defineEntity } from "./core";
export const UserRoleEntityDef = defineEntity({
    name: "user-role",
    schema: UserRoleRelationSchema,
    relations: {},
});
